<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">{{ $store.state.themeTitle }}室老师考勤</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1">
          </OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择" style="width:320px;" @focus="dialogOpen1"
            @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item label="老师姓名">
          <el-input v-model="formInline.name" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="工号">
          <el-input v-model="formInline.number" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <custom-table-column prop="name" fixed label="老师姓名" width="100px">
        </custom-table-column>
        <custom-table-column prop="number" label="工号" width="150">
        </custom-table-column>
        <custom-table-column prop="department" label="院系" min-width="160px">
        </custom-table-column>
        <custom-table-column prop="major" label="专业" min-width="160px">
        </custom-table-column>
        <!-- <custom-table-column prop="class" label="班级" min-width="160px">
        </custom-table-column> -->
        <custom-table-column prop="attendance_count" label="本学期考勤次数" width="160px">
        </custom-table-column>
        <custom-table-column prop="absence_count" label="本学期缺勤次数" width="160px">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="text" @click="handleChildren(scope.row)" size="small">查看详情</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" title="考勤详情" :visible.sync="detailDialogVisible" width="986px">
      <div>
        <custom-table :data="tableData1" border style="width: 100%">
          <custom-table-column fixed label="序号" type="index" width="50">
          </custom-table-column>
          <custom-table-column prop="attendance_date" fixed label="日期" width="100px">
          </custom-table-column>
          <custom-table-column prop="attendance_status" fixed label="考勤结果" width="100px">
          </custom-table-column>
          <custom-table-column prop="course_name"  label="课程名称" min-width="160px">
          </custom-table-column>
          <custom-table-column prop="room"  label="教室" min-width="160px">
          </custom-table-column>
          <custom-table-column prop="checkin_time"  label="标准打卡时间" width="210px">
          </custom-table-column>
          <custom-table-column prop="checkout_time"  label="考勤打卡时间" width="160px">
          </custom-table-column>
        </custom-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';

export default {
  name: 'equipmentInto',
  mixins: [mixinList, mixinOrgan],
  data() {
    return {
      formInline: {
        type: 'teacher',
        name: '',
        number: '',
        structure_1: '',
        structure_2: '',
        class: '',
      },
      formInline1: {
        person_no: ''
      },
      levell: [1, 2],
      detailDialogVisible: false,
      tableData1: [],
      loading: false,
    };
  },
  created() {
  },
  mounted() {
  },
  methods: {
    handleChildren(row) {
      this.formInline1.person_no = row.username
      this.tableData1 = []
      this.detailDialogVisible = true;
      this.handleQuery1()
    },
    handleQuery1() {
      this.$nextTick(() => {
        this.getList1();
      });
    },
    async getList1() {
      let res = await this.$api.instance.interfaceServer(`api/attendance/detail`, 'get',this.formInline1);
      if (res.code == 0 && res.data) {
        this.tableData1 = res.data;
      }
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/attendance/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    handleQuery() {
      this.beforeQueryByKey("structure_1", "structure_2")
      this.$refs.pageChild.page = 1;
      this.getList();
    },
  },
};
</script>
<style lang="less">
.pageHeader:before {
  width: var(--width);
}

.el-cascader-node {
  height: auto !important;
  line-height: 2;
}

.el-cascader__dropdown {
  max-width: 100% !important;
  overflow: auto;
}

.el-cascader-node__label {
  line-height: 1.2;
}

.cascader-tip {
  color: rgb(132, 146, 166);
  font-size: 13px;
  max-width: 400px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin-bottom: 12px;
}
</style>
